import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ButtonsUseStyles from 'consts/styles/Buttons';
import InsideLoader from 'components/common/InsideLoader';
import { FiltersDetailsUseStyles } from './FiltersDetailsUseStyles';

const ZonesCategoriesFilter = props => {
  const {
    setZonesCategoriesFilters,
    zonesCategories,
    language,
    zonesCategoriesFilters,
  } = props;

  const classesFilters = FiltersDetailsUseStyles();
  const classesButtons = ButtonsUseStyles();

  React.useEffect(() => {
    setZonesCategoriesFilters(zonesCategories.map(z => z.uid));
  }, [zonesCategories]);

  const toggleSource = categoryUid => {
    const indexOfZone = zonesCategoriesFilters.indexOf(categoryUid);
    const zones = [...zonesCategoriesFilters];
    if (indexOfZone === -1) zones.push(categoryUid);
    else zones.splice(indexOfZone, 1);
    setZonesCategoriesFilters(zones);
  };

  const isSelected = categoryUid =>
    !!zonesCategoriesFilters.includes(categoryUid);

  const button = zonesCategories.map(category => (
    <Button
      key={category.uid}
      type="button"
      className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
      variant={isSelected(category.uid) ? 'contained' : 'outlined'}
      onClick={() => toggleSource(category.uid)}
      color='primary'
    >
      {language.zonesDetails.categories[category.name] || category.name}
    </Button>
  ));

  const buttonAll = (
    <Button
      type="button"
      className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesFilters.FiltersDetails}__table__details__container__button--big ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
      variant={
        zonesCategories.length === zonesCategoriesFilters.length
          ? 'contained'
          : 'outlined'
      }
      onClick={
        () =>
          setZonesCategoriesFilters(
            zonesCategoriesFilters.length >= 0 &&
              zonesCategoriesFilters.length < zonesCategories.length
              ? zonesCategories.map(zone => zone.uid)
              : []
          )
        // eslint-disable-next-line react/jsx-curly-newline
      }
      color='primary'
    >
      {language.zonesDetails.categories.all}
    </Button>
  );

  return (
    <>
      {zonesCategories.length ? (
        <div className={`${classesFilters.FiltersDetails}__table__details`}>
          {language.zonesDetails.infra_}
          <div
            className={`${classesFilters.FiltersDetails}__table__details__scroll`}
          >
            <Grid item>{button}</Grid>
          </div>
          <Grid key="all" item xs={12}>
            {buttonAll}
          </Grid>
        </div>
      ) : null}
      {!zonesCategories.length ? <InsideLoader /> : null}
    </>
  );
};

ZonesCategoriesFilter.propTypes = {
  zonesCategories: PropTypes.array.isRequired,
  setZonesCategoriesFilters: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  zonesCategoriesFilters: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  zonesCategories: state.zonesCategories,
  language: state.language,
});

export default connect(mapStateToProps)(ZonesCategoriesFilter);
